import { createContext } from 'react';
import type { MatrixClient } from 'matrix-js-sdk';
import type { ChatConnectionStatus, ChatRoomSummary } from '@/types/chat';

export interface ChatContextValue {
  readonly status: ChatConnectionStatus;
  readonly rooms: readonly ChatRoomSummary[];
  readonly unreadTotal: number;
  /** Живой matrix-js-sdk клиент (для диалога: таймлайн/отправка в P2). null — пока не подключён. */
  readonly client: MatrixClient | null;
  /** Принудительный повторный коннект (после ошибки/протухания токена). */
  readonly reconnect: () => void;
}

// Контекст в отдельном файле (не в ChatProvider.tsx) — провайдер-компонент экспортирует только компонент,
// что сохраняет корректный React Fast Refresh.
export const ChatContext = createContext<ChatContextValue | undefined>(undefined);
